import { pantryColors } from '@pantry/ui'
import React from 'react'

const p = pantryColors

// Mockup `.type-tag` — Type column / drawer pill. Email = blue, SMS = teal,
// Abandoned Cart and other always-on flows = orange (mockup `cart`).
export type ListRowType = 'email' | 'sms' | 'abandoned_cart' | 'flow'

export const TYPE_TAG_TINTS: Record<
  ListRowType,
  { fg: string; bg: string; label: string }
> = {
  email: { fg: p.blue[700], bg: p.blue[50], label: 'Email' },
  sms: { fg: p.teal[700], bg: p.teal[50], label: 'SMS' },
  abandoned_cart: {
    fg: p.orange[700],
    bg: p.orange[50],
    label: 'Abandoned Cart',
  },
  flow: { fg: p.orange[700], bg: p.orange[50], label: 'Flow' },
}

export const TypeTag: React.FC<{ type: ListRowType }> = ({ type }) => {
  const tint = TYPE_TAG_TINTS[type]
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 11,
        fontWeight: 700,
        padding: '3px 9px',
        borderRadius: 20,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        background: tint.bg,
        color: tint.fg,
        whiteSpace: 'nowrap',
      }}
    >
      {tint.label}
    </span>
  )
}
